<template>
  <v-row
    v-if="
      $auth.loggedIn &&
      user &&
      !(user.cookiesModal == true || user.cookiesModal == undefined)
    "
    justify="center"
    class="my-0"
  >
    <v-dialog v-model="cookiesDialog" persistent max-width="300">
      <v-card light>
        <v-card-title>
          <div class="title">Cookies &amp; Privacy</div>
        </v-card-title>
        <v-card-text class="pb-0">
          This website uses cookies to ensure you get the best experience on our
          website.
        </v-card-text>

        <v-card-actions class="pa-4 text-left">
          <v-btn
            color="primary caption lighten-2"
            rounded
            dark
            @click="closeCookiesModal"
          >
            Accept and Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      cookiesDialog: true
    }
  },
  computed: {
    user() {
      return this.$store.state.profile.data
    }
  },
  methods: {
    async closeCookiesModal() {
      await this.$store.dispatch('profile/closeCookiesModal')
      this.cookiesDialog = false
    }
  }
}
</script>
